const toggleTextInformation = toggle => {
  toggle.closest(".js-information-text").classList.toggle("open");
};

export default () => {
  document.querySelectorAll(".js-information-text-toggle").forEach(toggle => {
    toggle.addEventListener("click", () => toggleTextInformation(toggle));
  });
};
